import { jsx as e } from "react/jsx-runtime";
import { forwardRef as p } from "react";
import { T as m } from "./index3.js";
const { Paragraph: a, Text: T } = m, c = p(
  ({ appearance: t, inline: o, ...r }, n) => /* @__PURE__ */ e(o ? T : a, { ...r, ref: n, type: t })
);
export {
  c as T
};
